import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-yanzhengma",
  "use": "icon-icon-yanzhengma-usage",
  "viewBox": "0 0 56 56",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 56 56\" id=\"icon-icon-yanzhengma\">\n<path fill-rule=\"evenodd\" opacity=\"0\" fill=\"rgb(25, 49, 88)\" d=\"M-0.006,-0.006 L55.994,-0.006 L55.994,55.994 L-0.006,55.994 L-0.006,-0.006 Z\" />\n<path fill-rule=\"evenodd\" fill=\"rgb(99, 133, 164)\" d=\"M36.766,20.624 C36.572,20.632 36.381,20.634 36.194,20.634 C31.286,20.634 29.120,18.522 29.102,18.504 L28.614,17.1000 L28.120,18.504 C28.100,18.527 25.980,20.634 21.031,20.634 C20.844,20.634 20.653,20.632 20.459,20.624 L19.769,20.601 L19.769,30.178 C19.769,32.684 20.661,36.342 28.372,39.140 L28.614,39.227 L28.856,39.140 C36.567,36.342 37.459,32.684 37.459,30.178 L37.459,20.601 L36.766,20.624 M27.853,32.654 L23.411,28.725 L24.589,27.771 L26.952,29.510 C26.952,29.510 30.213,26.141 33.364,24.566 L33.814,25.072 C33.814,25.072 29.878,28.331 27.853,32.654 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-yanzhengma.svg
// module id = ykwP
// module chunks = 97